import React, { forwardRef } from 'react';
import { BaseFormProps, StyledBase } from '../base/Base';
import { FormField, FormFieldProps } from '../formField/FormField';

export interface TextareaProps extends BaseFormProps, FormFieldProps {
  rows?: number;
  maxLength?: number;
}
const StyledTextArea = StyledBase.withComponent('textarea');
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      label,
      id,
      rows,
      invalid,
      defaultValue,
      placeholder,
      required,
      errorMessage,
      hideLabel,
      disabled,
      hintText,
      maxLength,
      onFocus,
      ...rest
    },
    ref
  ) => (
    <FormField
      fieldAs="div"
      label={label}
      htmlFor={id}
      invalid={invalid}
      errorMessage={errorMessage}
      hideLabel={hideLabel}
      hintText={hintText}
      disabled={disabled}
      {...rest}
    >
      <StyledTextArea
        rows={rows}
        id={id}
        name={id}
        invalid={invalid}
        ref={ref}
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
        required={required}
        onFocus={onFocus}
        aria-describedby={hintText && `${id}-hint`}
        maxLength={maxLength}
      />
    </FormField>
  )
);
Textarea.displayName = 'Textarea';
